module.exports = function() {
  return new Worker(__webpack_public_path__ + "e73308f7334d6a9f7678.worker.js");
};